
import { Invoice } from "../../classes"
import moment from 'moment'
const InvoiceModule = {
  namespaced: true,
  state: {
    invoices: null,
    invoice: null,
    invoiceExport: null,
    invoiceContract: [],
    invoiceOverall: [],
    invoiceOverallMarketId: '',
    invoiceOverallProjectId: '',
    invoiceOverallMonthly: [],
    invoiceOverallMonthlyMarketId: '',
    invoiceOverallMonthlyProjectId: '',
    invoicesRecognizance:[],
  },
  mutations: {
    setInvoices(state, invoices) {
      state.invoices = invoices || []
    },
    setInvoiceExport(state, invoiceExport) {
      state.invoiceExport = invoiceExport || []
    },
    setInvoice(state, invoice) {
      state.invoice = invoice
      // if (state.invoices && state.invoices.length) {
      //   let index = state.invoices.findIndex(i => i.objectId === invoice.objectId);
      //   state.invoices[index] = invoice

      //   const temp = state.invoices
      //   state.invoices = []
      //   state.invoices = temp
      // } else {
      //   state.invoices = [invoice]
      // }
    },
    setInvoicesOverall(state, invoices) {
      state.invoiceOverall = invoices || []
    },
    setInvoiceOverallMarketId(state, marketId) {
      state.invoiceOverallMarketId = marketId || ''
    },
    setInvoiceOverallProjectId(state, projectId) {
      state.invoiceOverallProjectId = projectId || ''
    },
    setInvoiceOverallMonthly(state, invoices) {
      state.invoiceOverallMonthly = invoices || []
    },
    setInvoiceOverallMonthlyMarketId(state, marketId) {
      state.invoiceOverallMonthlyMarketId = marketId || ''
    },
    setInvoiceOverallMonthlyProjectId(state, projectId) {
      state.invoiceOverallMonthlyProjectId = projectId || ''
    },
    updateInvoice(state, invoice) {
      if (state.invoices && state.invoices.length) {
        let index = state.invoices.findIndex(i => i.objectId === invoice.objectId);
        state.invoices[index] = invoice;

        const temp = state.invoices
        state.invoices = []
        state.invoices = temp
      } else {
        state.invoices = [invoice]
      }

      if (state.invoiceExport && state.invoiceExport.length) {
        let index = state.invoiceExport.findIndex(i => i.objectId === invoice.objectId);
        state.invoiceExport[index] = invoice;

        const temp = state.invoiceExport
        state.invoiceExport = []
        state.invoiceExport = temp
      } else {
        state.invoiceExport = [invoice]
      }
    },
    setInvoiceContract(state, payload) {
      state.invoiceContract = payload
    },
    removeInvoice(state, invoiceId) {
      if (state.invoices) {
        let index = state.invoices.findIndex(d => d.objectId == invoiceId)
        if (index > -1) {
          state.invoices.splice(index, 1)
        }
      }
    },
    setInvoicesRecognizance(state, invoices) {
      state.invoicesRecognizance = invoices || []
    },
    addInvoices(state, invoices) {
      state.invoices = state.invoices.concat(invoices)
    }
  },
  actions: {
    createInvoice: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const params = Object.assign({}, payload)
        params.date = moment(params.date).startOf('day')
        params.dueDate = moment(params.dueDate).endOf("day")
        const data = await Invoice.createInvoice(params);
        return data;
      } catch (err) {
        throw err;
      }
    },
    createBookingInvoice: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const params = Object.assign({}, payload)
        params.date = moment(params.date).startOf('day')
        params.dueDate = moment(params.dueDate).endOf("day")
        const data = await Invoice.createBookingInvoice(params);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMonthlyInvoices: async ({ commit }, { projectId, marketId, meterMonth, meterYear }) => {
      try {
        let invoices = await Invoice.getMonthlyInvoices(projectId, marketId, meterMonth, meterYear)
        commit("setInvoices", invoices)
        return invoices
      } catch (error) {
        throw error
      }
    },
    getById: async ({ commit }, { invoiceId, marketId, projectId }) => {
      try {
        var result = await Invoice.getInvoice(invoiceId, marketId, projectId);
        commit('setInvoice', result)
        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    updateInvoice: async ({ commit }, postData) => {
      try {
        var result = await Invoice.updateInvoice(postData);
        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    sendInvoice: async ({ commit }, { id, date, dueDate }) => {
      try {
        var result = await Invoice.sendInvoice({ id, date, dueDate });

        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    unsendInvoice: async ({ commit }, invoiceId) => {
      try {
        var result = await Invoice.unsendInvoice(invoiceId);

        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    cancelInvoice: async ({ commit }, invoiceId) => {
      try {
        var result = await Invoice.cancelInvoice(invoiceId);
        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getInvoicesBetweenDateByProject: async ({ commit }, { projectId, startDate, endDate }) => {
      try {
        const data = await Invoice.getInvoicesBetweenDateByProject(projectId, startDate, endDate)
        commit("setInvoices", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getInvoicesBetweenDateByMarket: async ({ commit }, payload) => {
      try {
        const data = await Invoice.getInvoicesBetweenDateByMarket(payload)
        // if (isOverall)
        // commit("setInvoicesOverall", data)
        // else
        commit("setInvoices", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getInvoicesSentByContract: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Invoice.getInvoicesSentByContract(payload);
        commit("setInvoiceContract", data);
        // dispatch("example", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getInvoicesByContract: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Invoice.getInvoicesByContract(payload);
        commit("setInvoiceContract", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getInvoicesBySchedulerTask: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Invoice.getInvoicesBySchedulerTask(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getInvoiceContract: async ({ commit }, { invoiceId, marketId }) => {
      try {
        var result = await Invoice.getInvoice(invoiceId, marketId);
        commit('setInvoiceContract', [result])
        return result;
      } catch (err) {
        throw err;
      }
    },
    getInvoicesByContractInAppeal: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        let data = await Invoice.getInvoicesByContractInAppeal(payload);
        commit("setInvoiceContract", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getInvoicesRecognizanceByContract: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        let data = await Invoice.getInvoicesRecognizanceByContract(payload);
        commit("setInvoicesRecognizance", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getUnpaidInvoicesByMarket: async ({ commit }, payload) => {
      try {
        const data = await Invoice.getUnpaidInvoicesByMarket(payload)
        commit("setInvoices", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getUnpaidInvoicesByProject: async ({ commit }, fromData) => {
      try {
        const data = await Invoice.getUnpaidInvoicesByProject(fromData)
        commit("setInvoices", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingInvoicesByMarket: async ({ commit }, { marketId }) => {
      try {
        const data = await Invoice.getBookingInvoicesByMarket(marketId)
        // commit("setInvoices", data)
        return data
      } catch (error) {
        throw error
      }
    },
    removeInvoice: async ({ commit }, invoiceId) => {
      try {
        var result = await Invoice.removeInvoice(invoiceId);
        commit('removeInvoice', invoiceId)
        return result;
      } catch (error) {
        throw error
      }
    },
    updateInvoiceCustomerData: async ({ commit }, postData) => {
      try {
        var result = await Invoice.updateInvoiceCustomerData(postData);
        commit('updateInvoice', result)
        return result;
      } catch (error) {
        throw error
      }
    },

    //Overall Invoice
    getOverAllInvoices: async ({ commit, state }, payload) => {
      try {
        let invoices
        if (
          state.invoiceOverall
          && state.invoiceOverall.length
          && state.invoiceOverallMarketId == payload.marketId
          && state.invoiceOverallProjectId == payload.projectId
        ) {
          invoices = state.invoiceOverall
        } else {
          invoices = await Invoice.getOverAllInvoices(payload)
          commit("setInvoicesOverall", invoices)
          commit("setInvoiceOverallMarketId", payload.marketId)
          commit("setInvoiceOverallProjectId", payload.projectId)
        }
        return invoices
      } catch (error) {
        throw error
      }
    },
    getOverAllMonthlyInvoices: async ({ commit, state }, payload) => {
      try {
        let invoices
        if (
          state.invoiceOverallMonthly
          && state.invoiceOverall.length
          && state.invoiceOverallMonthlyMarketId == payload.marketId
          && state.invoiceOverallMonthlyProjectId == payload.projectId
        ) {
          invoices = state.invoiceOverallMonthly
        } else {
          invoices = await Invoice.getOverAllMonthlyInvoices(payload)
          commit("setInvoiceOverallMonthly", invoices)
          commit("setInvoiceOverallMonthlyMarketId", payload.marketId)
          commit("setInvoiceOverallMonthlyProjectId", payload.projectId)
        }
        return invoices
      } catch (error) {
        throw error
      }
    },
    getOverAllYearlyInvoices: async ({ }, payload) => {
      try {
        let invoices = await Invoice.getOverAllYearlyInvoices(payload)
        // commit("setInvoicesOverall", invoices)
        return invoices
      } catch (error) {
        throw error
      }
    },
    sendInvoices: async ({ commit }, payload) => {
      try {
        const data = await Invoice.sendInvoices(payload)
        return data
      } catch (error) {
        throw error
      }
    }

  },
  getters: {
    getInvoiceContract: (state) => state.invoiceContract,
    getInvoice: (state) => state.invoice,
    getInvoices: (state) => state.invoices ? state.invoices : [],
    getInvoiceOverall: (state) => state.invoiceOverall,
    getInvoiceOverallMonthly: (state) => state.invoiceOverallMonthly,
    getInvoicesRecognizance: (state) => state.invoicesRecognizance,
    getMonthlyInvoices: (state) => (month, year) => {
      return (state.invoices || []).filter(d => d.documentType == 1 && d.month == month && d.year == year)
    },
  },
};
export default InvoiceModule;
